// Wortlaute der Erklärung „Einstellungen“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Felder stehen so, wie die Seite sie zeigt (../settings.js,
// ../notification.js, ../billing.js, ../dataexport.js).
export default {
  title: "Einstellungen",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    SettingsOverview: "Einstellungen",
    EmployeeDetail: "Mitarbeiter",
    ProjectCostsForOne: "Projektkosten",
    TimeTrackingMy: "Meine Zeiten",
    PersonnelCalendar: "Einsatzplanung",
  },
  // Die Seiten außerhalb der Einstellungen, auf denen eine dieser Vorgaben überschrieben wird oder
  // sichtbar wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    head: {
      text: "Diese Seite gilt für den ganzen Arbeitsbereich, nicht für Ihr Konto. Die Zeile darunter nennt die Versionen von Oberfläche und Server.",
    },
    save: {
      text: "Speichern übernimmt die Felder aus Allgemein, die Bezeichnungen, die Standard-Rolle, geänderte Rollen und die Schwellen der Benachrichtigungen. Alles andere hier wirkt sofort.",
    },

    "tab-general": {
      text: "Allgemein hält, was überall gilt. Logo, Währung, Wochenbeginn, Arbeitgeberanteil und die Anschrift des Betriebs.",
    },
    logo: {
      text: "Das Logo steht links oben im Menü neben dem Firmennamen. Es wird sofort hochgeladen, als PNG oder JPEG bis 2 MB.",
    },
    currency: {
      text: "Standardwährung und Währungs-Schema legen fest, wie Beträge angezeigt werden. Das Schema bestimmt Trennzeichen und Stellung des Währungszeichens.",
    },
    weekstart: {
      text: "Der Wochenbeginn gilt für jede Datumsauswahl, für Kalender, für Meine Zeiten und für die Wochentabelle der Projektkosten.",
    },
    contribution: {
      text: "Der Arbeitgeberanteil schlägt in der Nachkalkulation auf die Personalkosten auf. Am Mitarbeiter kann ein eigener Satz stehen, der dann vorgeht.",
    },
    daysubmission: {
      text: "Ist der Schalter an, sendet die App jede Tagesmeldung mit Standort. Ohne Freigabe nimmt sie nicht auf, und findet das Handy keinen, reicht sie ihn bis zu 15 Minuten später nach.",
    },
    timeentry: {
      text: "Ist der Schalter an, stempelt die App das Kommen und trägt eine Kolonne erst nach, wenn der Standort freigegeben und eingeschaltet ist. Gehen ist immer möglich.",
    },
    address: {
      text: "Diese Anschrift steht als Absender auf jeder PDF, etwa auf Rechnungen und [[cr.datpl]]. Der Firmenname lässt sich hier nicht ändern.",
    },

    "tab-terminology": {
      text: "Bezeichnungen legt fest, wie Ihr Betrieb seine Unterlagen nennt. Etwa Tagelohnschein, Regieschein oder Regierapport statt Stundenlohnbericht.",
    },
    "terminology-names": {
      text: "Je Unterlage eine Bezeichnung, aus der Liste oder frei getippt. Sie steht danach überall in Lewara und auf neu gedruckten PDFs. Jede Sprache hat eigene, das Sprachmenü über der Tabelle wählt, welche sie zeigt.",
    },
    "terminology-preview": {
      text: "Der Satz zeigt die Auswahl im Zusammenhang. Stimmen Artikel und Mehrzahl hier, stimmen sie überall.",
    },

    "tab-rights": {
      text: "Berechtigungen legt fest, wer was sehen und ändern darf. Eine Rolle gilt für alle Personen, die sie haben.",
    },
    "default-role": {
      text: "Die Standard-Rolle ist bei einem neuen Login-Benutzer schon eingetragen. Im Formular lässt sie sich noch ändern.",
    },
    "role-list": {
      text: "Hier stehen alle Rollen des Betriebs. Welche Rolle jemand hat, steht am Mitarbeiter auf dem Reiter System spezifisch.",
    },
    "role-rights": {
      text: "Ein Klick auf eine Rolle öffnet ihre Rechte. Administrator hat immer alle Rechte und lässt sich nicht ändern.",
    },
    "role-tree": {
      text: "Ein Klick auf eine Gruppe öffnet ihre einzelnen Rechte. Ein Recht, das ein anderes voraussetzt, setzt dieses mit und sperrt es. Ein leeres Feld heißt, dass es das Recht für diesen Punkt nicht gibt, etwa kein eigenes Löschen für einen Preis.",
    },
    "role-close": {
      text: "Das Kreuz verwirft die Änderungen an dieser Rolle. Gespeichert werden sie erst mit Speichern unten.",
    },

    "tab-absence": {
      text: "Abwesenheitsarten sind die Gründe, aus denen jemand fehlt. Zugewiesen werden sie in der Einsatzplanung oder in Zeiten prüfen. Bezahlte Arten schreibt die Zeiterfassung dem Arbeitszeitkonto gut.",
    },
    "absence-default": {
      text: "Diese sechs Arten bringt jeder Arbeitsbereich mit. Ihre Farben zeichnen die Balken der Einsatzplanung und die freien Tage in der Zeiterfassung. Der Schalter Bezahlt gilt auch rückwirkend.",
    },
    "absence-custom": {
      text: "Eigene Arten legen Sie mit Namen und Farbe an. Das Plus speichert sie sofort, ein Speichern unten braucht es dafür nicht.",
    },

    "tab-notification": {
      text: "Benachrichtigungen legt fest, wann die Glocke oben etwas meldet. Jede Überwachung ist eine Zeile mit eigenem Häkchen.",
    },
    "notify-levels": {
      text: "Die Spalten Warnung und Kritisch legen fest, ab welchem Wert eine Meldung in welcher Stufe erscheint. Die Zahl an der Glocke ist nach der dringendsten ungelesenen Meldung gefärbt.",
    },
    "notify-invoicing": {
      text: "Nach so vielen Tagen ohne Rechnung oder ohne [[cr]] meldet sich ein Projekt. Der Klick öffnet den Rechnungs-Assistenten oder den Berichtsreiter.",
    },
    "notify-costs": {
      text: "Marge, Budgetverbrauch, Margenrückgang und Leistungsrückstand melden ein Projekt, das aus dem Ruder läuft. Der Klick führt in die Nachkalkulation oder den Leistungskatalog.",
    },
    "notify-time": {
      text: "Fehlende Tage, offene Freigaben und eine laufende Erfassung melden sich hier. Der Klick führt in die Prüfung oder auf die Anwesenheitstafel.",
    },
    "notify-documents": {
      text: "Dokumente melden sich, bevor ihre Frist abläuft, und der Klick öffnet den Ordner gefiltert. Der E-Mail-Schalter oben schickt Meldungen zusätzlich per E-Mail.",
    },

    worktimemodel: {
      text: "Arbeitszeitmodelle gehören zur Zeiterfassung. Die Erklärung dort zeigt, wie daraus Sollstunden, Rundung und Pausen entstehen.",
    },

    "pdf-templates": {
      text: "Je Dokument steht hier, womit es gedruckt wird. „Anpassen“ legt fest, was es zeigt und auf welchem Briefpapier. Weitere Vorlagen kann ein Projekt für sich wählen.",
    },

    "pdf-letterheads": {
      text: "Ein Briefpapier legt fest, wie die Seiten aussehen: Logo, Fußzeile, Schrift und Farben. „Für Dokumente verwenden“ stellt die gewählten Dokumente darauf um.",
    },

    "tab-billing": {
      text: "Abonnement zeigt den Tarif dieses Arbeitsbereichs. Zusatzmodule wie die Zeiterfassung schalten hier ihre Bereiche frei.",
    },
    "billing-plan": {
      text: "Hier stehen Tarif, belegte Plätze und gebuchte Zusatzmodule. Ist Ihr Arbeitsbereich von der Abrechnung ausgenommen, steht hier nur ein Hinweis.",
    },
    "billing-manage": {
      text: "Tarif wechseln und Zahlungsmittel führen auf eigene Seiten. Kündigen wirkt zum Ende der Laufzeit und braucht das Recht dafür.",
    },

    "tab-dataexport": {
      text: "Datenexport gibt Ihnen alle Daten des Arbeitsbereichs heraus. Nur die Rolle Administrator sieht diesen Reiter.",
    },
    "export-request": {
      text: "Export anfordern stellt ein ZIP-Archiv in die Warteschlange. Es entsteht im Hintergrund, Sie können die Seite verlassen.",
    },
    "export-list": {
      text: "Die Liste zeigt jede Anforderung mit Status, Inhalt und Größe. Ein fertiges Archiv wird nach Ablauf der Frist gelöscht.",
    },

    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },

    "employee-tabs": {
      text: "Am Mitarbeiter gelten eigene Werte. System spezifisch hält, was die Person darf, Unternehmens-relevant, was der Betrieb mit ihr rechnet.",
    },
    "employee-roles": {
      text: "Hier wird die Rolle zugewiesen. Die Standard-Rolle aus den Einstellungen ist nur der Vorschlag beim Anlegen.",
    },
    "employee-contribution": {
      text: "Steht hier ein eigener Arbeitgeberanteil, gilt er statt des Satzes aus den Einstellungen. Leer heißt, der allgemeine Satz zählt.",
    },

    "costs-contribution": {
      text: "Steht ein Arbeitgeberanteil hinterlegt, steckt er in den bisherigen Kosten jedes Projekts. Die Lohnkosten sind dann Vollkosten.",
    },
    "times-weekstart": {
      text: "Der Wochenbeginn legt fest, mit welchem Tag diese Woche anfängt. Ist, Soll und Saldo daneben zählen genau diese sieben Tage.",
    },
    "planning-absence": {
      text: "Die Abwesenheitsarten werden hier zugewiesen. Ein Balken erscheint in der Farbe seiner Art und geht der Farbe des Projekts vor.",
    },
  },
  // Was der Zeiger tippt. Ein Beispielname, der nie gespeichert wird.
  typed: {
    absence: "Fortbildung",
  },
}
